import { helper as buildHelper } from '@ember/component/helper';
import config from 'mewe/config';
import Storage from 'mewe/shared/storage';
import CurrentUserStore from 'mewe/stores/current-user-store';

// copied from is-mewe-team.js
function getPrimaryEmail() {
  const primaryEmail = CurrentUserStore.getState().get('primaryEmail') || '';
  const primaryPhone = CurrentUserStore.getState().get('primaryPhoneNumber') || '';

  if (!primaryEmail && !primaryPhone) return false;

  return (
    primaryEmail.indexOf('@sgrouples.com') !== -1 ||
    primaryEmail.indexOf('@mewe.com') !== -1 ||
    primaryEmail.indexOf('@fakemail.groupl.es') !== -1 ||
    primaryEmail.indexOf('@groupl.es') !== -1 ||
    primaryPhone.indexOf('+89') !== -1
  );
}

function shouldAllow() {
  const isMeWeTeam = getPrimaryEmail();
  const hasLsFlag = Storage.get(Storage.keys.internalToolsEnabled);
  // checking host just to be double sure, althout it seems totally redundant
  const isProd = config.environment === 'prod' || location.host.indexOf('mewe.com') !== -1;
  return !isProd || (isMeWeTeam && hasLsFlag);
}

// TRUE for non-production
// TRUE for production if user has email from list above and has LS flag "internalToolsEnabled" set to true
export function allowInternalTools() {
  return shouldAllow();
}

export default buildHelper(allowInternalTools);
